// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { AnimatePresence } from "framer-motion";
import "./styles/global.scss";
import "./styles/dashboard.scss";
import "./styles/home.scss";
import "./styles/product.scss";
import "./styles/about.scss";
import "./styles/checkout.scss";
import "./styles/preorder.scss";
import "./styles/auth.scss";
import "./styles/orders.scss";
import "./styles/tracking.scss";
import "./styles/ai-chat.scss";
import "./styles/public-profile.scss";
import App from "./App";

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Application Error:", error);
    console.error("Error Info:", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>Something went wrong</h1>
          <p>
            We're sorry for the inconvenience. Please try refreshing the page.
          </p>
          <button onClick={() => window.location.reload()}>Refresh Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Add baseline styles
const style = document.createElement("style");
style.textContent = `
  html, body, #root {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    height: auto;
    width: 100%;
  }
  #root {
    display: flex;
    flex-direction: column;
  }
  .error-boundary {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    text-align: center;
    font-family: 'Inter', sans-serif;
  }
  .error-boundary h1 {
    color: #006B2E;
    font-family: 'Montserrat', sans-serif;
  }
  .error-boundary p {
    color: #5A5A5A;
    max-width: 500px;
  }
  .error-boundary button {
    padding: 12px 24px;
    background: #D9A321;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  .error-boundary button:hover {
    background: #B8860B;
    transform: translateY(-2px);
  }
`;
document.head.appendChild(style);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <AnimatePresence mode="wait">
          <App />
        </AnimatePresence>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);